import * as billingActionTypes from 'modules/billing/actionTypes';
import {
  FETCH_INTERNAL_METRICS_REQUEST,
  RECEIVED_INTERNAL_METRICS,
  FETCH_USERS_REQUEST,
  RECEIVED_USERS,
  FETCH_METRICS_BY_ORGANIZATION_REQUEST,
  RECEIVED_ORGANIZATION_METRICS,
} from './actionTypes';

export const initialInternalMetricsTableState = {
  headers: [],
  data: {},
  isLoading: false,
  total: 0,
  users: [],
  organizationMetrics: {
    projects: [],
  },
};

type InteralMetricsReducerActionTypes = {
  type:
    | typeof FETCH_INTERNAL_METRICS_REQUEST
    | typeof RECEIVED_INTERNAL_METRICS
    | typeof FETCH_USERS_REQUEST
    | typeof RECEIVED_USERS
    | typeof FETCH_METRICS_BY_ORGANIZATION_REQUEST
    | typeof RECEIVED_ORGANIZATION_METRICS
    | typeof billingActionTypes.GET_ORG_USAGE_DATA_SUCCESS
    | typeof billingActionTypes.GET_ORG_USAGE_DATA_REQUEST
    | typeof billingActionTypes.CLEAR_ORG_USAGE_DATA;
  [key: string]: any;
};

const internalMetricsReducer = (
  state = initialInternalMetricsTableState,
  action: InteralMetricsReducerActionTypes,
) => {
  switch (action.type) {
    case FETCH_INTERNAL_METRICS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RECEIVED_INTERNAL_METRICS:
      return {
        ...state,
        data: action.internalMetrics,
        isLoading: false,
      };
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RECEIVED_USERS:
      return {
        ...state,
        users: action.users,
        isLoading: false,
      };
    case FETCH_METRICS_BY_ORGANIZATION_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RECEIVED_ORGANIZATION_METRICS:
    case billingActionTypes.GET_ORG_USAGE_DATA_SUCCESS:
      return {
        ...state,
        organizationMetrics: action.organizationMetrics,
        isLoading: false,
      };
    case billingActionTypes.GET_ORG_USAGE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case billingActionTypes.CLEAR_ORG_USAGE_DATA:
      return {
        ...initialInternalMetricsTableState,
      };
    default: {
      return state;
    }
  }
};

export default internalMetricsReducer;
